import { Component, inject, OnDestroy } from '@angular/core'
import { ModalHeaderComponent } from '../modal-header/modal-header.component'
import { ModalBodyComponent } from '../modal-body/modal-body.component'
import { ModalFooterComponent } from '../modal-footer/modal-footer.component'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Subscription } from 'rxjs'
import { ActiveFilterListComponent } from '../../table/filters/active-filter-list/active-filter-list.component'
import { SelectorComponent } from '../../selector/selector.component'
import { BoolDisplayPipe } from 'src/app/shared/pipes/boolDisplay.pipe'
import { LabeledPropertyComponent } from '../../labeled-property/labeled-property.component'
import { FlagFilter } from 'src/app/shared/services/filter/flag-filter'
import { Filter, FilterService } from 'src/app/shared/services/filter/filter.service'
import { HeaderModal } from '../../table/headers/table-header.component'

interface Option {
  value: boolean | null
  display: string
}

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    ActiveFilterListComponent,
    SelectorComponent,
  ],
  selector: 'app-flag-filter-modal',
  styles: '',
  template: `
    @if(filter) {
        <div app-modal-header>{{ filter.state.config.meta.fieldDisplay }}</div>
        <div app-modal-body>
            <p>Select a filter value for the column {{ filter.state.config.meta.fieldDisplay }} below</p>
            <div app-labeled-property [label]="filter.state.config.meta.fieldDisplay">
            <div
                app-selector
                [selected]="boolToFlagOption(filter.state.value)"
                [options]="options"
                [slim]="true"
                (selectedChange)="onSelect($event)"
            ></div>
            </div>
            <app-active-filter-list
            [filterGroup]="filter.state.config.meta.fieldGroup"
            [filterName]="filter.state.config.meta.fieldName"
            ></app-active-filter-list>
        </div>
        <div app-modal-footer>
            <button class="action-btn" (click)="onClose()">Close</button>
        </div>
    }
    `,
})
export class FlagFilterModalComponent implements HeaderModal, OnDestroy {
  private modal = inject(NgbActiveModal)
  private filterService = inject(FilterService)

  private subscription = new Subscription()
  public options: Option[] = [
    { value: null, display: 'Either' },
    { value: true, display: new BoolDisplayPipe().transform(true) },
    { value: false, display: new BoolDisplayPipe().transform(false) },
  ]

  public filter: FlagFilter | undefined

  public init(
    fieldGroup: string,
    fieldName: string,
  ): void {
    this.subscription.add(
      this.filterService.state(fieldGroup).subscribe((group) => {
        const filter = group[fieldName] as Filter | undefined
        if(filter?.type === 'FLAG') {
          this.filter = filter
        }
      }),
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  public boolToFlagOption(b: boolean | null): Option {
    switch(b) {
      case null: return this.options[0]
      case true: return  this.options[1]
      case false: return  this.options[2]
    }
  }

  public onSelect(event: { value: boolean | null; display: string }) {
    if(this.filter) {
      this.filterService.dispatch(
        FlagFilter.SetFlagFilterValueAction({
          value: event.value,
        },
        this.filter.state.config.meta),
      )
    }
  }

  public onClose() {
    this.modal.close()
  }
}
